import { AfterViewInit, Component, EventEmitter, Input, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { DxDropDownBoxComponent } from 'devextreme-angular';
import { DxDataGridComponent } from 'devextreme-angular/ui/data-grid';
import { ComboBoxValidationStatus, IComboboxStyle } from '../../../base/src/abcCombobox/abcCbxGrid';

@Component({
    selector: '',
    template: `
    <div class="devExDropDownStyle">
      <dx-drop-down-box
        #dxDropDown
        [id]="id"
        [stylingMode]="stylingMode"
        [(value)]="value"
        [dropDownOptions]="selectedValue"
        [rtlEnabled]="rtlEnabled"
        [deferRendering]="true"
        [displayExpr]="onDisplayExpr"
        [(valueExpr)]="valueExpr"
        useSelectMode="true"
        [readOnly]="readOnly"
        [label]="label"
        [openOnFieldClick]="true"
        [hoverStateEnabled]="hoverDropDown"
        [showClearButton]="showClearButton"
        [dataSource]="gridData"
        [disabled]="disabled"
        [isValid]="isValid"
        [visible]="visible"
        [validationStatus]="validationStatus"
        [hoverStateEnabled]="hoverStateEnabled"
        [class]="class"
        [width]="width"
        [height]="height"
        [acceptCustomValue]="true"
        (onOpened)="opened($event)"
        (onInitialized)="initialized($event)"
        (onClosed)="close($event)"
        (onChange)="onValueChanges($event)"
        (onValueChanged)="valueChange($event)"
        (mouseenter)="isEllipsisActive(id)"
        (mouseleave)="toggleDefault()"
        (onKeyDown)="onKeyDown($event)"
        labelMode="floating"
      >
        <dx-data-grid
          #dxDataGrid
          [ngStyle]="{ 'max-height': '100%', 'min-width': '100px', 'min-height': '200px' }"
          [dataSource]="gridData"
          [columns]="columnsHeader"
          [selection]="{ mode: 'single' }"
          [hoverStateEnabled]="true"
          [class]="class"
          [showColumnHeaders]="showColumnHeader"
          [allowColumnResizing]="allowColumnResizing"
          [paging]="{ enabled: true, pageSize: 10 }"
          [scrolling]="{ mode: 'virtual' }"
          [(selectedRowKeys)]="value"
          [(keyExpr)]="valueExpr"
          [height]="'100%'"
          [noDataText]="''"
          [filterValue]="defaultFilter"
          (onRowClick)="onValueChanges($event)"
        >
          <dxo-data-grid-filter-row [visible]="showGridFilterRow"></dxo-data-grid-filter-row>
          <dxo-data-grid-load-panel [enabled]="false" [showPane]="false"></dxo-data-grid-load-panel>

          <dxo-data-grid-filter-panel [visible]="isFilterPanelEnabled"></dxo-data-grid-filter-panel>
        </dx-data-grid>
        <abcLoader [id]="'loader-grid'" [show]="showLoader"></abcLoader>
      </dx-drop-down-box>
      <dx-popover
        class="popover-style"
        #componentRef
        [id]="id"
        [target]="'#' + id"
        [(visible)]="displayTooltip"
        [(contentTemplate)]="value"
      >
      </dx-popover>
      <span id="rulertoCalculateWidth"></span>
    </div>
  `,
    styleUrls: ['./devExDropDown.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    standalone: false
})
export class DevExDropDownComponent implements AfterViewInit {
  @ViewChild('dxDropDown', { static: true }) public dxDropDown: DxDropDownBoxComponent;
  @ViewChild('dxDataGrid', { static: true }) dxDataGrid: DxDataGridComponent;
  @Input() gridData: any;
  @Input() columnsHeader: any;
  @Input() id: string;
  public showLoader: boolean = true;
  private _label: string;
  @Input()
  public get label(): string {
    return this._label;
  }
  public set label(value: string) {
    this._label = value;
  }
  @Input() datafields: any;
  @Input() caption: string;
  @Input() dataAdapter: any;
  @Input() source: any;
  @Input() columns: any;
  @Input() gridHeight: string;
  @Input() isEditable: boolean;
  @Input() maxHeight: string;
  @Input() hoverDropDown: boolean = false;
  @Input() showClearButton: boolean = false;
  @Input() stylingMode;
  @Input() rtlEnabled;
  @Input() deferRendering: boolean = true;
  @Input() showGridFilterRow: boolean = false;
  @Input() allowColumnResizing: boolean = false;
  @Input() selectedValue;
  @Input() disabled: boolean;
  @Input() hoverStateEnabled: boolean;
  @Input() isValid: boolean = true;
  @Input() visible: boolean;
  @Input() validationStatus: ComboBoxValidationStatus;
  @Input() class: string;
  @Input() width: string;
  @Input() height: string;
  @Input() value: any;
  private _showColumnHeader: boolean = true;
  @Input()
  get showColumnHeader() {
    return this._showColumnHeader;
  }
  set showColumnHeader(val: boolean) {
    this._showColumnHeader = val;
  }
  @Input() valueExpr: string = 'Id';
  @Output() onChange: EventEmitter<any> = new EventEmitter();
  @Output() onValueChange: EventEmitter<any> = new EventEmitter();
  @Output() onOpened = new EventEmitter();
  readOnly: boolean = false;
  @Input() displayExpr: string | Function;
  @Input() isFilterPanelEnabled: boolean = false;
  defaultFilter: any;
  selectedItemId: string;
  valueDropdown: string;
  isOpened: boolean = false;
  displayTooltip: boolean = false;
  parentElement: HTMLElement;
  currentElement: HTMLElement;
  selectedkeyValue: string;

  constructor() {}

  ngAfterViewInit(): void {
    const dropDown = this.dxDataGrid.instance;
    new ResizeObserver(() => {
      dropDown.updateDimensions();
    }).observe(dropDown.element());
    if (this.showColumnHeader && this.dxDropDown?.instance?.option('dropDownOptions.height')) {
      this.dxDropDown.instance.option('dropDownOptions.height', 200);
      this.dxDropDown.instance.option('dropDownOptions.minWidth', 300);
      this.dxDropDown.instance.option('dropDownOptions.resizeEnabled', true);
    }
  }
  setSelectStyle(style: IComboboxStyle) {
    const element = this.dxDropDown['element'].nativeElement;
    if (style) {
      if (style.disabled === true) {
        this.readOnly = true;
      }
      for (const key in style) {
        if (key) {
          element.style[key] = style[key];
        }
      }
    }
  }

  onDisplayExpr = (item) => {
    if (item === undefined || item === null) {
      return '';
    }
    if (this.displayExpr) {
      if (typeof item == 'string') {
        return item;
      } else {
        if (typeof this.displayExpr === 'string') return item[this.displayExpr];
        else return this.displayExpr(item);
      }
    } else {
      if (typeof item == 'string') return item;
      else return item.toString();
    }
  };

  public onComboboxOpen(column, data, displayExpr, valueExpr?, selectedId?): void {
    this.displayExpr = displayExpr;
    this.valueExpr = valueExpr || displayExpr;
    this.gridData = data;
    this.dxDropDown.value = this.value;
    this.showLoader = false;
    this.selectedkeyValue = this.selectedItemId ? this.selectedItemId : selectedId;
    if (column) this.columnsHeader = this.convertDataToDevExGridFormat(column);
    //Timeout has to be removed//
    setTimeout(() => {
      this.dxDataGrid.instance.navigateToRow(this.selectedkeyValue);
      this.dxDataGrid.selectedRowKeys = [this.selectedkeyValue];
    }, 300);
  }

  onValueChanges(e): void {
    const value = Array.isArray(this.value) ? this.value[0] : this.value;
    this.selectedkeyValue = value;
    if (this.gridData && e.data?.Id) {
      this.selectedItemId = e.data.Id;
    } else if (this.gridData && e.data?.Value) {
      this.selectedItemId = e.data.Value;
    } else if (this.gridData && e.data?.id) {
      this.selectedItemId = e.data.id;
    } else if (Array.isArray(e.values)) {
      this.selectedItemId = e.values[0];
    } else {
      this.selectedItemId = e.values;
    }
    if (e.key) {
      this.value = e.key;
    }
    if (e.previousValue !== value) this.dxDropDown.instance.close();
    this.onChange.emit({ newValue: this.selectedItemId, value: this.value });
  }

  onKeyDown(e) {
    if (!this.isEditable) {
      e.event.preventDefault();
    }
  }

  onOptionChanged(e): void {
    e.value = this.selectedItemId;
  }

  public opened(event): void {
    if (this.gridData) {
      this.showLoader = false;
    }
    this.onOpened.emit(event);
  }

  initialized(e) {
    this.dxDropDown.instance.registerKeyHandler('del', () => {
      this.value = null;
      this.onChange.emit(null);
    });
  }

  change(e) {
    // this.onChange.emit({ newValue: e.value, value: e.value });
  }

  valueChange(e) {
    this.onValueChange.emit({ newValue: e.value, value: e.value, id: this.selectedItemId });
  }

  close(e) {}
  toggleDefault() {
    this.displayTooltip = false;
  }

  isEllipsisActive(id) {
    this.parentElement = document.getElementById(id).querySelector('.dx-texteditor-input-container');
    let widthParentElement = this.parentElement.offsetWidth;

    if (!this.value) {
      this.displayTooltip = false;
    } else {
      if (this.getSelectedValueWidth(this.value) >= widthParentElement) {
        this.displayTooltip = true;
      }
    }
  }

  private getSelectedValueWidth(v: any): number {
    const ruler = document?.getElementById('rulertoCalculateWidth');
    if (ruler) {
      ruler.innerHTML = v;
      return ruler.offsetWidth;
    }
    return 0;
  }

  private convertDataToDevExGridFormat(data: any) {
    data = data.map((item) => ({
      dataField: item.dataField,
      caption: item.displayName || item.name,
      dataType: item.type,
      visible: this.isFilterInitiallyEnabled(item) ? false : !item.hidden,
    }));
    return data;
  }

  private isFilterInitiallyEnabled(item) {
    if (item.dataField === '__DefaultFilter') {
      const _defaultFilter = {
        dataField: item.dataField,
        filterOperator: '=',
        value: '1',
      };
      this.isFilterPanelEnabled = true;
      this.defaultFilter = [_defaultFilter.dataField, _defaultFilter.filterOperator, _defaultFilter.value];
      this.dxDataGrid.instance.filter(this.defaultFilter);
      return true;
    }
    return false;
  }
}
